<template>
    <div :class="hasBigTapArea ? 'checkbox-input--big-tap-area' : ''">
        <div :class="inputClass">
            <div class="checkbox-input__option" @click="changeInputValue()">
                <input
                    :checked="value"
                    :data-checked="value"
                    :autofocus="hasAutofocus"
                    :required="isRequired"
                    :disabled="isDisabled"
                    type="checkbox"
                    @change="change(!value)"
                />

                <label>
                    <span v-if="secondLabel" :class="secondLabelClass">
                        {{ secondLabel }}
                    </span>

                    <common-icon
                        v-if="type === 'checkbox'"
                        class="checkbox-input__icon"
                        :name="checkboxIcon"
                        :size="iconSize"
                    ></common-icon>

                    <div v-else-if="type === 'switch'" :class="switchClass">
                        <div :class="dotClass"></div>
                    </div>

                    <span class="checkbox-input__label">
                        <slot name="label">
                            {{ label }}
                        </slot>
                    </span>
                </label>
            </div>
            <span v-if="showInfoTip">
                <common-info-tip :containerDimensions="containerDimensions">
                    <span>{{ infoTipMessage }}</span>
                </common-info-tip>
            </span>
        </div>

        <span v-if="errorMessage" class="form-input-text--error">{{ errorMessage }}</span>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: Boolean, default: false },
            color: { type: String, default: 'primary' },
            type: { type: String, default: 'checkbox' },
            labelPosition: { type: String, default: 'right' },
            hasBigTapArea: { type: Boolean, default: false },
            showInfoTip: { type: Boolean, default: false },
            infoTipMessage: { type: String, default: '' },
            containerDimensions: { type: Object, default: undefined },
            secondLabel: { type: String, default: '' },
            iconSize: { type: String, default: 'large' },
        },

        computed: {
            checkboxIcon() {
                return this.value ? `${this.type}-on` : `${this.type}-off`
            },

            inputClass() {
                return {
                    'checkbox-input': true,
                    'checkbox-input--is-disabled': this.isDisabled,
                    'checkbox-input--big-tap-area': this.hasBigTapArea,
                    [`checkbox-input__label-position--${this.labelPosition}`]: true,
                    [`checkbox-input__option--${this.color}`]: true,
                }
            },

            switchClass() {
                return {
                    'checkbox-input__switch': true,
                    'checkbox-input__switch--open': this.value,
                }
            },

            dotClass() {
                return {
                    'checkbox-input__switch--dot': true,
                    [`checkbox-input__switch--dot-${this.value ? 'open' : 'closed'}`]: true,
                }
            },

            secondLabelClass() {
                return {
                    'checkbox-input__label': true,
                    'checkbox-input__label--active': this.value,
                }
            },
        },

        methods: {
            changeInputValue() {
                !this.isDisabled ? this.change(!this.value) : undefined
            },
        },
    }
</script>
